var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 40 128 88",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    role: "img",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2f2f",
    d: "M85.97 62.07L68.2 117.71l9.91 2.45l21.26-1.29l-1.03-35.93z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.74 44.29c-1.32.99-4.51 12.37-12.24 27.95s-17.65 36.2-17.65 36.2s1.16 1.67 15.84 6.96s26.81 7.61 26.81 7.61s32.7-50.9 32.96-52.05c.26-1.16 5.48-22.38 5.48-22.38s-20.81-1.45-29.83-2.22s-19.83-3.23-21.37-2.07z",
    fill: "#f19f40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.4 118.76l10.98-1.87s-10.13-21.19-15.67-31.88s-15.1-33.38-16-35.05s-4.64-2.45-6.31.52s-15.61 33.56-18.23 38.45c-2.95 5.5-17.61 32.59-17.74 34.01c-.13 1.42 24.68-.93 24.68-.93l6.4-18.85l7.73-33.49l1.29.26l6.18 27.31l16.69 21.52z",
    fill: "#ec5f32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.33 121.12c-.22 1.3-6.76 2.43-10.48 2.51c-3.73.09-10.4.35-11.18-.52c-.78-.87 8.4-9.01 14.3-19.67c5.89-10.66 9.36-18.02 10.22-20.97c.87-2.95 2.6-11.78 3.29-13.26s2.08-1.21 2.51.17c.43 1.39 4.94 18.46 6.5 22.53c1.56 4.07 7.97 12.56 9.88 15.25c1.91 2.69 11.35 9.85 11.52 10.54c.17.69-5.84 2.8-9.93 3.27c-2.93.33-9.76-.18-10.28-1.05c-.52-.87-4.05-23.94-5.35-31.65c-1.3-7.71-3.55-18.02-3.55-18.02s-5.11 24.78-5.81 31.37c-.69 6.59-1.3 17.42-1.64 19.5z",
    fill: "#9c2d1b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 98.52s.73-.76 2.11-.85c1.38-.08 2.6.76 2.6.76l.89 12.82s-1.06.93-2.36.93s-2.52-.68-2.52-.68L4.2 98.52z",
    fill: "#9c2d1b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.46 111.41s1.13-.95 2.86-.95s3.03.87 3.03.87l.09 13s-1.39.78-2.43.78c-1.04 0-2.69-.52-2.69-.52l-.86-13.18z",
    fill: "#9c2d1b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119 105.7s.93-1.08 2.58-1s2.55.65 2.55.65l-.78 13.34s-.61.87-2.08.87s-2.77-.69-2.77-.69l.5-13.17z",
    fill: "#9c2d1b"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTent);
export default __webpack_public_path__ + "static/media/tent.480ccded98cd223f8f1734ab7b7e005a.svg";
export { ForwardRef as ReactComponent };